<script setup lang="ts"></script>
<template>
    <VFooter class="footer">
        <div class="w-100 text-center my-6">
            {{ $t(`ca.default.configuration_app_a_matawan_application`) }}
        </div>
    </VFooter>
</template>
<style lang="scss" scoped>
.footer {
    max-height: fit-content;
    background: none;
}
</style>
